import { render, staticRenderFns } from "./zDrugStart.vue?vue&type=template&id=22661654&scoped=true"
import script from "./zDrugStart.vue?vue&type=script&lang=js"
export * from "./zDrugStart.vue?vue&type=script&lang=js"
import style0 from "./zDrugStart.vue?vue&type=style&index=0&id=22661654&prod&scoped=true&lang=css"
import style1 from "./zDrugStart.vue?vue&type=style&index=1&id=22661654&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22661654",
  null
  
)

export default component.exports